import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { CalendarRange, Check, ArrowRight } from "lucide-react";
import CarCard from "../../components/public/CarCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BENEFITS = [
  "Fast månedlig pris uden skjulte gebyrer",
  "Fleksibel længde — fra én måned og opefter",
  "Vejhjælp og forsikring kan tilkøbes",
  "Ingen langtidsbinding eller udbetaling",
];

export default function Langtidsleje() {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    axios.get(`${API}/public/cars?type=longterm`)
      .then((r) => setCars((r.data.cars || []).slice(0, 6)))
      .catch(() => {});
  }, []);

  return (
    <div className="bg-[#F7F3EC] min-h-screen" data-testid="langtidsleje-page">
      {/* Header */}
      <section className="bg-graphite text-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="label-tag text-copper mb-4">Langtidsleje</div>
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight mb-6">
              Bilen du har brug for — måned for måned.
            </h1>
            <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-2xl">
              Langtidsleje hos Mahasa giver dig friheden ved at have egen bil, uden de faste binder og store udbetalinger ved bilkøb. Vælg en bil, betal månedligt, og skift når dit behov skifter.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div>
            <div className="w-14 h-14 rounded-2xl bg-graphite text-copper flex items-center justify-center mb-6">
              <CalendarRange size={24} strokeWidth={1.6}/>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl text-graphite mb-4">Sådan virker det.</h2>
            <p className="font-body text-graphite/70 leading-relaxed mb-6">
              Du vælger en bil, vi aftaler en lejeperiode på minimum én måned, og du betaler en fast pris pr. måned. Behovet ændrer sig? Bilen kan skiftes ud eller leveres tilbage efter aftale.
            </p>
            <Link to="/kontakt" className="btn-outline inline-flex" data-testid="lt-contact-btn">
              Spørg om langtidsleje <ArrowRight size={16}/>
            </Link>
          </div>
          <div className="bg-white rounded-2xl p-8 border border-[#E5DED1]">
            <h3 className="font-heading text-2xl text-graphite mb-6">Fordele ved langtidsleje</h3>
            <ul className="space-y-4">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3" data-testid="lt-benefit">
                  <span className="w-6 h-6 rounded-full bg-copper/15 text-copper flex items-center justify-center shrink-0 mt-0.5">
                    <Check size={14} strokeWidth={2.5}/>
                  </span>
                  <span className="text-graphite/85 leading-snug">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Cars with monthly rate */}
      {cars.length > 0 && (
        <section className="pb-20 md:pb-28">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
              <div>
                <div className="label-tag mb-3">Tilgængelige biler</div>
                <h2 className="font-heading text-3xl md:text-4xl text-graphite">Biler til langtidsleje.</h2>
              </div>
              <Link to="/udlejning" className="text-copper hover:text-copper-dark font-medium text-sm inline-flex items-center gap-1.5">Se alle udlejnings­biler <ArrowRight size={14}/></Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {cars.map((c) => <CarCard key={c.license_plate} car={c} type="rent" mode="longterm" />)}
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="bg-graphite text-white py-20 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl mb-4">Klar til at finde din næste bil?</h2>
          <p className="text-white/70 mb-8">Skriv til os — vi finder en løsning der passer til dit behov og budget.</p>
          <Link to="/kontakt" className="btn-primary" data-testid="lt-cta-btn">
            Få et tilbud <ArrowRight size={18}/>
          </Link>
        </div>
      </section>
    </div>
  );
}
